import React from "react";
import styled from "styled-components";
import { EuiIcon } from "@elastic/eui";

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0;
`;

const SshStatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
`;

const SshCard = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid ${props => props.borderColor || 'rgba(255, 255, 255, 0.04)'};
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  .header-row {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.45);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    .icon {
      color: ${props => props.color || 'rgb(0, 128, 213)'};
    }
  }
  
  .count-value {
    font-size: 18px;
    font-weight: 800;
    color: #fff;
    font-family: Consolas, monospace;
    margin-top: 2px;
  }
`;

const SecurityFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.01);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  
  .status-icon {
    color: #48bb78;
    display: flex;
    align-items: center;
  }
`;

const ServerSshWidget = ({ server }) => {
    const metric = server?.metrics?.[0];
    let sA = 0;
    let fA = 0;

    if (metric) {
        if (metric?.ssh?.success_attempts !== undefined) {
            sA = parseInt(metric.ssh.success_attempts, 10) || 0;
        }
        if (metric?.ssh?.failed_attempts !== undefined) {
            fA = parseInt(metric.ssh.failed_attempts, 10) || 0;
        }
    }

    const hasFailedAttempts = fA > 0;

    return (
        <CardWrapper>
            {/* Security Attempt Cards Grid */}
            <SshStatsGrid>
                {/* Authorized Logins */}
                <SshCard color="#48bb78">
                    <div className="header-row">
                        <EuiIcon type="lock" size="s" className="icon" />
                        <span>Authorized</span>
                    </div>
                    <div className="count-value">{ sA }</div>
                </SshCard>

                {/* Failed Logins (Risk Alert) */}
                <SshCard 
                    color="#F86B63" 
                    borderColor={ hasFailedAttempts ? "rgba(248, 107, 99, 0.3)" : "rgba(255, 255, 255, 0.04)" }
                >
                    <div className="header-row">
                        <EuiIcon type="alert" size="s" className="icon" />
                        <span>Failed</span>
                    </div>
                    <div className="count-value" style={ hasFailedAttempts ? { color: "#F86B63" } : {} }>
                        { fA }
                    </div>
                </SshCard>
            </SshStatsGrid>

            {/* Monitoring Shield Footer */}
            <SecurityFooter>
                <div className="status-icon">
                    <EuiIcon type="securitySignal" size="s" />
                </div>
                <span>SSH Security Monitor Active</span>
            </SecurityFooter>
        </CardWrapper>
    );
};

export default ServerSshWidget;
